export const CHATS_ADD_NEW_MESSAGE = "chats/ADD_NEW_MESSAGE";
export const CHATS_START_SEND_MESSAGE_TO_CHATGPT =
  "chats/START_SEND_MESSAGE_TO_CHATGPT";
export const CHATS_RECEIVE_MESSAGE_FROM_CHATGPT =
  "chats/RECEIVE_MESSAGE_FROM_CHATGPT";
